module.exports = __webpack_public_path__ + "static/media/pause-in-circle-filled.7c1d007a.svg";